import React from 'react';
import Slide from 'react-reveal/Slide';

import {SectionTitle} from 'component/reuse/title';


const _features = [
  {
    "title": "Keep the team in sync", 
    "description": "Keep pushing the non-critical updates out on a shared channel and let the critical ones get to the right users", 
    "points": [
      "Send updates on chat channels and team emails for tracking",
      "Get alerted about unusual infrastructure activities",
      "Get alerted about async or cron task failures",
      "Consume digest of daily system health instead of getting alerts on non actionable events",
    ], 
    "img": {"src": "/static/images/features/01.svg", "alt": "", "size": "sm"}
  },
  {
    "title": "Customized subscriber experience", 
    "description": "Use the service as a broadcasting platform or let the users customize the importance of the channel for themselves", 
    "points": [
      "Let the subscribers choose the priority for themselves. An alert for a developer might be high, but the VP of Engg might be low",
      "In other words it's embarissing for a developer when the CTO tells them about a faliure they caused!",
      "Host a button on your service page for anyone to ping you regarding queries",
      "Templating option available for creating dynamic messages filled with notification context",
    ], 
    "img": {"src": "/static/images/features/02.svg", "alt": "", "size": "sm"}
  },
  {
    "title": "Trigger analytics", 
    "description": "Tracking and triggering analytics are generated automatically and available for slicing and dicing", 
    "points": [
      "Out of the box basic tacking analytics available as soon as you fire notifications",
      "Build company dashboards for everyone to look at everyday (place them on a TV in the common area)!",
      "Actionable insight generation (comin soon)",
    ], 
    "img": {"src": "/static/images/features/03.svg", "alt": "", "size": "md"}
  },
  {
    "title": "Build against our API", 
    "description": "We provide all data back in consumable API form for you to build your own workflows", 
    "points": [
      "Integrate with your CI / CD integrations to block builds if a success notification is not fired",
      "Integrate with your current APMs, to triggers alerts as any graph value spikes",
      "Your call .. We can't wait to hear how you plan to consume this data!",
    ], 
    "img": {"src": "/static/images/features/04.svg", "alt": "", "size": "sm"}
  },
]

export default class Features extends React.Component {
  render (){
    return (
      <section id="subscribe" className="content-section flex-center ">
        <div className="container-fluid container" >
          {/* <SectionTitle first="Value add" second="" background="primary" /> */}

          <FeatureSection item={_features[0]} flip={true}/>
          <hr className=""/>
          <FeatureSection item={_features[1]} />
          <hr className=""/>
          <FeatureSection item={_features[2]} flip={true}/>
          <hr className=""/>
          <FeatureSection item={_features[3]} />
          
        </div>
      </section>
    )
  }
}


class FeatureSection extends React.Component {
  render (){
    const is_mobile = window.innerWidth < 1200;
    const {item, flip } = this.props;

    const img_width = {
      "sm": 4,
      "md": 6,
      "lg": 8,
    }[item.img.size]

    return (
      // <div className="my-5 py-1">
      <div className="my-2 row">

      {(flip)? '': <FeatureImg item={item} img_width={img_width} flip={flip} />}
        <div className={"d-flex align-items-center col-md-" + (12 - img_width) + ((is_mobile && flip)? ' order-2 my-3': ' my-5')}>
          <Slide bottom>
          <div className="flex-left text-black-3 ">
          <h2 className="my-3">{item.title}</h2>
          <h5 className="my-3">{item.description}</h5>
          <ul className="my-3">
            {item.points.map(function(point, idx){
              return(
                <li key={"_"+idx} className="my-2">{point}</li>
              )
            })}
          </ul>
          </div>
          </Slide>
        </div>
        {(flip)? <FeatureImg item={item} img_width={img_width} flip={flip} />: ""}

      </div>
      
      // </div>
    )
  }
}

function FeatureImg(props){
  const is_mobile = window.innerWidth < 1200;
  const {item, img_width, flip} = props;
  return(
    <div className={"align-self-center col-md-"+ (img_width) + ((is_mobile && flip)? ' order-1 my-3': ' my-5')}>
      {/* <Slide left={!flip} right={flip}> */}
        <img className={"img img-fluid rounded p-3" + (is_mobile? ' mx-auto d-block': ' ')} src={item.img.src} alt={item.img.alt} />
      {/* </Slide> */}
    </div>
  )
}